import { Flex, Box } from '@chakra-ui/react';
import React from 'react';
import Typography from './Typography.js';
import CloseIcon from '../icons/CloseIcon.js';
import InfoFilled from '../icons/InfoFilled.js';
import CheckCircle from '../icons/CheckCircle.js';
import CloseFilled from '../icons/CloseFilled.js';

var Status;
(function (Status) {
    Status["Warning"] = "warning";
    Status["Info"] = "info";
    Status["Success"] = "success";
    Status["Error"] = "error";
    Status["Default"] = "default";
})(Status || (Status = {}));
var BannerIcon = function (_a) {
    var bannerStatus = _a.bannerStatus;
    var iconMap = {
        warning: (React.createElement(InfoFilled, { height: "16px", width: "16px", color: "warning.800" })),
        info: (React.createElement(InfoFilled, { height: "16px", width: "16px", color: "informational.700" })),
        success: (React.createElement(CheckCircle, { height: "16px", width: "16px", color: "success.700" })),
        error: (React.createElement(CloseFilled, { height: "16px", width: "16px", color: "error.700" })),
        default: (React.createElement(InfoFilled, { height: "16px", width: "16px", color: "rgba(97, 106, 117, 1)" })),
    };
    var bannerIcon = iconMap[bannerStatus] || (iconMap === null || iconMap === void 0 ? void 0 : iconMap.default);
    return React.createElement(React.Fragment, null, bannerIcon);
};
var CustomFlex = function (_a) {
    var hasBackground = _a.hasBackground, hasBorder = _a.hasBorder, bannerColours = _a.bannerColours, children = _a.children;
    return (React.createElement(Flex, { background: hasBackground ? bannerColours === null || bannerColours === void 0 ? void 0 : bannerColours.backgroundColor : "neutrals.white", p: "12px 12px 12px 8px", flexDirection: "column", height: "100%", width: "100%", boxShadow: "0px 3px 8px 0px rgba(87, 102, 117, 0.06), 0px 6px 12px 0px rgba(106, 115, 129, 0.16)", borderLeft: hasBorder ? "3px solid" : "", borderRadius: "4px", borderColor: bannerColours === null || bannerColours === void 0 ? void 0 : bannerColours.borderColor }, children));
};
var Banner = function (_a) {
    var _b;
    var title = _a.title, status = _a.status, onDismiss = _a.onDismiss, body = _a.body, footer = _a.footer, _c = _a.hasBorder, hasBorder = _c === void 0 ? false : _c, _d = _a.hasBackground, hasBackground = _d === void 0 ? false : _d;
    var bannerColours = (_b = {},
        _b[Status.Warning] = {
            backgroundColor: "warning.100",
            borderColor: "warning.800",
        },
        _b[Status.Info] = {
            backgroundColor: "informational.100",
            borderColor: "informational.700",
        },
        _b[Status.Success] = {
            backgroundColor: "success.100",
            borderColor: "success.700",
        },
        _b[Status.Error] = {
            backgroundColor: "error.100",
            borderColor: "error.700",
        },
        _b[Status.Default] = {
            backgroundColor: "#f1f2f4",
            borderColor: "rgba(97, 106, 117, 1)",
        },
        _b);
    return (React.createElement(CustomFlex, { hasBackground: hasBackground, hasBorder: hasBorder, bannerColours: bannerColours[status] || (bannerColours === null || bannerColours === void 0 ? void 0 : bannerColours.default) },
        React.createElement(Flex, { height: "100%", justify: "space-between", align: "start", gap: "8px" },
            React.createElement(Flex, null,
                React.createElement(BannerIcon, { bannerStatus: status })),
            React.createElement(Flex, { flexDirection: "column", flex: 1, maxWidth: "calc(100% - 45px)" },
                React.createElement(Typography, { lineHeight: "20px", fontWeight: 500, variant: "subheading2" }, title),
                body && React.createElement(Box, { mt: "4px" }, body),
                footer && (React.createElement(Box, { mt: "12px", display: "flex", flexWrap: "wrap" }, footer))),
            onDismiss && (React.createElement(Flex, null,
                React.createElement(CloseIcon, { height: "15px", width: "15px", cursor: "pointer", onClick: function () {
                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                    } }))))));
};

export { Status, Banner as default };
//# sourceMappingURL=Banner.js.map
